import produce from 'immer'

import { Types } from './actions'

export const INITIAL_STATE = {
  loadings: {
    getReserves: false,
    searchVoucher: false,
    setVoucherRedeemed: false
  },
  errors: {
    getReserves: false,
    searchVoucher: false,
    setVoucherRedeemed: false
  },
  attempts: {
    getReserves: 0
  },
  reserves: [],
  voucher: {},
  newConsumer: {}
}

export default function voucherReducers (state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case Types.searchVoucher: {
        draft.loadings.searchVoucher = true
        draft.errors.searchVoucher = false
        break
      }
      case Types.updateActiveVoucher: {
        draft.loadings.searchVoucher = false
        draft.errors.searchVoucher = action?.payload?.error || false

        draft.voucher = action?.payload?.voucher || {}
        break
      }
      case Types.setVoucherRedeemed: {
        draft.loadings.setVoucherRedeemed = true
        draft.errors.setVoucherRedeemed = false
        break
      }
      case Types.updateVoucherRedeemed: {
        draft.loadings.setVoucherRedeemed = false
        draft.errors.setVoucherRedeemed = action?.payload?.error || false

        if (action?.payload?.redeemed) {
          draft.voucher = {
            ...state.voucher,
            ...action?.payload?.data,
            redeemed: true
          }
        }
        break
      }
      case Types.getReserves: {
        draft.loadings.getReserves = true
        draft.errors.getReserves = false
        break
      }
      case Types.updateReserves: {
        draft.loadings.getReserves = false
        draft.errors.getReserves = action?.payload?.error || false
        draft.attempts.getReserves = state.attempts.getReserves + 1

        let treatReserves = []
        if (action?.payload?.reserves && action?.payload?.reserves.length > 0) {
          const actualBatch = action.payload.reserves.filter(e => (e?.vouchers && e?.vouchers.length > 0))[0]

          if (actualBatch && actualBatch.vouchers.length > 0) {
            treatReserves = actualBatch.vouchers
          }
        }

        draft.reserves = treatReserves
        break
      }
      case Types.updateNewConsumer: {
        draft.newConsumer = action?.payload?.newConsumer
        break
      }
      default:
    }
  })
}
